import { SlotFileSet } from 'editor/src/store/design/types';

/**
 * The positions, in the layout's option list, of the options a picture set shows under. The set
 * remembers labels, so editing or reordering the options before generating keeps the choice; a
 * label that no longer exists is dropped, and a choice with nothing left means every option,
 * since a picture shown under no option could never be picked.
 */
function getSlotFileSetOptionIndexes(
  fileSet: Pick<SlotFileSet, 'options'>,
  productOptions: string[],
): number[] | undefined {
  if (!fileSet.options) {
    return undefined;
  }
  const indexes = fileSet.options.map((label) => productOptions.indexOf(label)).filter((index) => index !== -1);
  return indexes.length && indexes.length < productOptions.length ? indexes.sort((a, b) => a - b) : undefined;
}

export default getSlotFileSetOptionIndexes;
